import { closeSnackbar, enqueueSnackbar } from 'notistack';
import { t } from '@/core/localization';
import { useAppSelector } from '@/warehouse/hooks';
import { useEffect } from 'react';
const connectionSnackbarKey = 'socket.connection.error.snackbar.key';
/**
 * Keeps a persistent snackbar in sync with the SignalR connection state.
 * Runs in an effect, so notistack is always initialized by then — unlike a dispatch-time
 * call, which can happen before React has mounted anything.
 *
 * This extraction to separate component fixes the following bug: https://global-parts.atlassian.net/browse/GPI-605
 */
export const SocketConnectionSnackbar = () => {
    const isAnyHubDown = useAppSelector(
    // null means the user has no access to that group, so it is not a broken connection
    (state) => state.shared.isCrossdockHubConnectionActive === false || state.shared.isLocationHubConnectionActive === false);
    useEffect(() => {
        if (!isAnyHubDown) {
            closeSnackbar(connectionSnackbarKey);
            return;
        }
        enqueueSnackbar({
            variant: 'reconnect',
            body: t('establishing.a.realtime.connection.label'),
            persist: true,
            key: connectionSnackbarKey,
            preventDuplicate: true,
        });
    }, [isAnyHubDown]);
    return null;
};
